import * as actionTypes from "../actions/actionTypes";

const initialState = {};
const getReferralRecordReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_REFERRAL_RECORD:
      return {
        referralRecord: action.payload.referralRecord,
      };

    default:
      return state;
  }
};
export default getReferralRecordReducer;
